import React from "react";
import LegalLayout, { LEGAL_ENTITY } from "../../components/LegalLayout";

export default function TermsPage() {
  const sections = [
    {
      heading: "Obiectul contractului",
      body: [
        "Site-ul www.visdezi.ro (denumit în continuare „Site-ul”) este operat de Alina Stancu PFA și comercializează cărți de colorat originale sub brandul VIS DE ZI.",
        "Prin plasarea unei comenzi pe acest Site, acceptați integral acești Termeni și Condiții. Dacă nu sunteți de acord cu oricare dintre aceste prevederi, vă rugăm să nu utilizați Site-ul.",
      ],
    },
    {
      heading: "Produse și prețuri",
      body: [
        "Toate produsele VIS DE ZI sunt cărți fizice tipărite, originale, create de Alina Stancu.",
        "Prețurile sunt afișate în RON (Lei) și includ TVA conform legislației în vigoare, atunci când este aplicabil. Prețurile nu includ costul de livrare, care este calculat separat la finalizarea comenzii.",
        "Ne rezervăm dreptul de a modifica prețurile în orice moment. Prețul aplicabil este cel afișat la momentul plasării comenzii.",
      ],
    },
    {
      heading: "Comandă și contract",
      body: [
        "Pentru a plasa o comandă, selectați produsele dorite, le adăugați în coș, completați formularul de livrare și confirmați comanda.",
        "Contractul de vânzare se consideră încheiat în momentul în care primim comanda dumneavoastră și o confirmăm prin email.",
        "Ne rezervăm dreptul de a refuza sau anula orice comandă în caz de informații incorecte, suspiciune de fraudă sau stoc indisponibil, cu notificare prealabilă.",
      ],
    },
    {
      heading: "Livrare și plată",
      body: [
        "Livrarea se face prin curier rapid în 24-48 ore lucrătoare după expediere, în toată România.",
        "Costul de livrare este de 20 RON, respectiv gratuit pentru comenzile de peste 150 RON.",
        "Momentan acceptăm plata ramburs la curier. Pentru detalii complete, consultați pagina Livrare și retur.",
      ],
    },
    {
      heading: "Dreptul de retragere",
      body: [
        "Conform OUG 34/2014, aveți dreptul să vă retrageți din contract fără a oferi un motiv, în termen de 14 zile calendaristice de la primirea produsului.",
        "Detaliile procedurii de retur sunt disponibile pe pagina Livrare și retur.",
      ],
    },
    {
      heading: "Drepturi de autor",
      body: [
        "Toate ilustrațiile, textele, logo-urile și designul publicat pe Site, precum și paginile de colorat din cărțile VIS DE ZI sunt proprietatea exclusivă a Alina Stancu și sunt protejate de legislația privind drepturile de autor.",
        "Este interzisă reproducerea, distribuirea, modificarea sau utilizarea comercială a oricărui element fără acordul scris prealabil al autoarei.",
        "Cumpărarea unei cărți VIS DE ZI vă oferă dreptul de a o colora pentru uz personal, nu dreptul de a reproduce sau comercializa paginile.",
      ],
    },
    {
      heading: "Răspundere",
      body: [
        "Depunem toate eforturile ca descrierile, pozele și prețurile de pe Site să fie corecte și actuale. Cu toate acestea, culorile reale ale cărților pot varia ușor față de cele afișate pe ecran din cauza setărilor monitorului dumneavoastră.",
        "Nu suntem răspunzători pentru întârzierile de livrare cauzate de curier sau de situații de forță majoră.",
      ],
    },
    {
      heading: "Protecția datelor personale",
      body: [
        "Prelucrăm datele dumneavoastră personale în conformitate cu Regulamentul (UE) 2016/679 (GDPR). Pentru detalii complete, consultați Politica de confidențialitate.",
      ],
    },
    {
      heading: "Modificări",
      body: [
        "Ne rezervăm dreptul de a modifica acești Termeni și Condiții în orice moment. Versiunea aplicabilă este cea afișată pe Site la momentul plasării comenzii.",
      ],
    },
    {
      heading: "Litigii",
      body: [
        "Orice litigiu se va soluționa pe cale amiabilă. În caz contrar, competența revine instanțelor judecătorești române.",
        "Alternativ, puteți apela la platforma SOL (Soluționare Online a Litigiilor): https://ec.europa.eu/consumers/odr sau la ANPC.",
      ],
    },
  ];

  return (
    <LegalLayout
      eyebrow="Document legal"
      title="Termeni și condiții"
      lastUpdated="1 octombrie 2026"
      sections={sections}
      legalEntity={LEGAL_ENTITY}
    />
  );
}
